import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { modularStore } from '@/stores/v2/modular'
import WoononListProduct from '@/components/v2/WoononListProduct.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'WoononModularProductsDesktop',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createBlock(_component_a_tabs, { "tab-position": "left" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modularStore)().groupedElements, (groupedElement, index) => {
        return (_openBlock(), _createBlock(_component_a_tab_pane, {
          tab: groupedElement.commercial_name,
          class: "modular-tabs",
          key: index
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, {
              gutter: [16,16],
              class: "no-mb"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, {
                      gutter: [16,16],
                      class: "no-mb"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedElement.elements, (element) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: element.id
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.products, (product) => {
                              return (_openBlock(), _createBlock(_component_a_col, {
                                span: 24,
                                key: product.id
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(WoononListProduct, {
                                    store: _unref(modularStore)(),
                                    product: product,
                                    isConfigurable: element.is_configurable_by_customer
                                  }, null, 8, ["store", "product", "isConfigurable"])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ], 64))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["tab"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})